<template>
	<section :id="['container-' + index + '-' + locationData.type]" :class="['container-' + locationData.type]">
		<div class="container-lg">
			<div class="row">
				<div class="col-12 col-lg-6 map-frame">
					<MapComponent v-if="locationData.config.map.type == 'OpenStreetMap'"
						:mapId="['container-' + index + '-' + locationData.type]"
						:latitude="locationData.config.map.coordinates.latitude"
						:longitude="locationData.config.map.coordinates.longitude" :showAddress="locationData.config.showAddress"
						:type="locationData.config.map.type" />

					<MapComponent v-else-if="locationData.config.map.type == 'FileMap'"
						:mapId="['container-' + index + '-' + locationData.type]" :showAddress="locationData.config.showAddress"
						:type="locationData.config.map.type" :path="locationData.config.map.path" />
				</div>
				<div class="col-12 col-lg-6 location-description-wrapper">
					<h2 class="location-headline" v-if="locationData.config.title">{{ locationData.config.title }}</h2>
					<span>{{ locationData.config.areaDescription }}</span>
				</div>
			</div>
		</div>
		<hr class="horizontal-line">
	</section>
</template>

<script>
import MapComponent from "../MapComponent.vue";

export default {
	props: {
		locationData: {
			type: Object,
		},
		index: {
			type: Number
		},
	},

	components: {
		MapComponent
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/design-turin/locationComponent.scss";
</style>